import { Helmet } from "react-helmet";
import BannerContacto from "../components/BannerContacto.js";
import Footer from "../components/Footer.js";
import NavBar from "../NavBar.js";
import NavBarTop from "../NavBarTop.js";
import env from "../config.js";
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ContactoTecnico from "../components/ContactoTecnico.jsx";
import { InfoPqr1 } from "./InfoPqr1.jsx";
import { InfoPqr2 } from "./InfoPqr2.jsx";
import { InfoPqr3 } from "./InfoPqr3.jsx";
import { useForm } from "../hooks/useForm.js";

import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";

let urlMedia = env.url;

const defaultForm = {
  anioModelo: "",
  anonimo: "false",
  apellidos: "",
  archivos: [],
  asunto: "",
  autorizacion: false,
  barrio: "",
  celular: "",
  ciudad: "",
  ciudadveh: "",
  correo: "",
  departamento: "",
  descripcion: "",
  direccion: "",
  linea: "",
  marca: "",
  nombres: "",
  numeroId: "",
  placa: "",
  sede: "",
  telefono: "",
  tipoId: "",
  tipoSolicitud: "",
  valcorreo: "",
  vehAdquirido: "true",
};

export const InfoPqr = () => {
  const navigate = useNavigate();

  const { formState, onInputChange, onResetForm, setArchivos } =
    useForm(defaultForm);

  const [pagina, setPagina] = useState(1);

  const paginaSiguiente = () => {
    if (pagina === 1 && formState.anonimo === "false") {
      if (
        !formState.tipoId ||
        !formState.numeroId ||
        !formState.nombres ||
        !formState.apellidos ||
        !formState.correo ||
        !formState.valcorreo ||
        formState.correo !== formState.valcorreo ||
        !formState.celular ||
        !formState.departamento ||
        !formState.ciudad ||
        !formState.direccion ||
        formState.numeroId.length < 6 ||
        formState.celular.length < 7
      ) {
        if (formState.correo !== formState.valcorreo) {
          // Verifica si el correo y el correo de verificación son diferentes
          toast.error(
            "El correo de verificación no coincide con el correo principal"
          );
        } else {
          toast.error(
            "Por favor complete todos los campos obligatorios en la página 1"
          );
        }
        return;
      }
    } else if (pagina === 1 && formState.anonimo === "true") {
      if (
        !formState.nombres ||
        !formState.apellidos ||
        !formState.correo ||
        !formState.valcorreo ||
        formState.correo !== formState.valcorreo ||
        !formState.celular ||
        !formState.departamento ||
        !formState.ciudad ||
        !formState.direccion
      ) {
        if (formState.correo !== formState.valcorreo) {
          // Verifica si el correo y el correo de verificación son diferentes
          toast.error(
            "El correo de verificación no coincide con el correo principal"
          );
        } else {
          toast.error(
            "Por favor complete todos los campos obligatorios en la página 1"
          );
        }
        return;
      }
    }
    if (pagina === 2 && formState.vehAdquirido === "true") {
      if (
        !formState.placa ||
        !formState.ciudadveh ||
        !formState.sede ||
        !formState.marca ||
        !formState.linea ||
        !formState.anioModelo
      ) {
        toast.error(
          "Por favor complete todos los campos obligatorios en la página 2"
        );
        return;
      }
    }

    // Si todas las validaciones pasan, permite avanzar a la siguiente página
    setPagina(pagina + 1);
  };

  const paginaAnterior = () => {
    console.log(formState);
    if (pagina == 1) return;
    setPagina(pagina - 1);
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      for (const key in formState) {
        if (key === "archivos") {
          Object.values(formState[key]).forEach((file) => {
            formData.append("files", file);
          });
        }
        formData.append(key, formState[key]);
      }

      const response = await axios
        .post("https://www.pqrsvehicentro.com/api/pqrs", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => console.log(response));

      const numeroSolicitud = response.data.data.numeroSolicitud;

      navigate(`/MensajePqrs?numeroSolicitud=${numeroSolicitud}`);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Helmet>
        <title>Pqrs | Vehicentro</title>
        <meta name="description" content="Pqrs" />
      </Helmet>
      <NavBarTop />
      <form action="submit" onSubmit={enviarFormulario}>
        {pagina == 1 ? (
          <InfoPqr1 onInputChange={onInputChange} formState={formState} />
        ) : pagina == 2 ? (
          <InfoPqr2 onInputChange={onInputChange} formState={formState} />
        ) : (
          <InfoPqr3
            onInputChange={onInputChange}
            formState={formState}
            setArchivos={setArchivos}
          />
        )}
        <div className="modeloBotones">
          <div className="modeloBotonizq">
            {pagina == 1 && <button className="modeloBotonnum1">1</button>}
            {pagina != 1 && <button className="modeloBotonnum">1</button>}

            {pagina == 2 && <button className="modeloBotonnum1">2</button>}
            {pagina != 2 && <button className="modeloBotonnum">2</button>}

            {pagina == 3 && <button className="modeloBotonnum1">3</button>}
            {pagina != 3 && <button className="modeloBotonnum">3</button>}
          </div>

          <div className="modeloBotonder">
            <button
              onClick={paginaAnterior}
              className="modeloBoton1"
              tabIndex={14}
            >
              Anterior
            </button>
            {pagina != 3 && (
              <button
                onClick={paginaSiguiente}
                className="modeloBoton1"
                tabIndex={13}
              >
                Siguiente
              </button>
            )}
            {pagina == 3 && (
              <button type="submit" className="modeloBoton1" tabIndex={7}>
                Enviar Solicitud
              </button>
            )}
          </div>
        </div>
      </form>

      {/* <CenterContact/> */}
      <ToastContainer />
      <BannerContacto />
      <Footer />
    </>
  );
};

function Modal() {
  return <div id="modalContainer"></div>;
}
